import { render, staticRenderFns } from "./trainCreationCompetition.vue?vue&type=template&id=1a407e4f&scoped=true"
import script from "./trainCreationCompetition.vue?vue&type=script&lang=js"
export * from "./trainCreationCompetition.vue?vue&type=script&lang=js"
import style0 from "./trainCreationCompetition.vue?vue&type=style&index=0&id=1a407e4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a407e4f",
  null
  
)

export default component.exports